import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import GLightbox from "glightbox";
import { BsLink45Deg, BsZoomIn } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import "glightbox/dist/css/glightbox.min.css";

const projectData = {
  filters: [
    { label: "All", value: "*" },
    { label: "Remodeling", value: ".filter-remodeling" },
    { label: "Construction", value: ".filter-construction" },
    { label: "Repairs", value: ".filter-repairs" },
    { label: "Design", value: ".filter-design" }
  ],
  items: [
    {
      id: 1,
      category: "filter-remodeling",
      imgSrc: require("../assets/img/projects/remodeling-1.jpg"),
      title: "App 1",
      subtitle: "Lorem ipsum, dolor sit amet consectetur",
      gallery: "portfolio-gallery-app",
      detailsLink: "/project-details"
    },
    {
      id: 2,
      category: "filter-construction",
      imgSrc: require("../assets/img/projects/construction-1.jpg"),
      title: "Product 1",
      subtitle: "Lorem ipsum, dolor sit amet consectetur",
      gallery: "portfolio-gallery-product",
      detailsLink: "/project-details"
    },
    {
      id: 3,
      category: "filter-repairs",
      imgSrc: require("../assets/img/projects/repairs-1.jpg"),
      title: "Branding 1",
      subtitle: "Lorem ipsum, dolor sit amet consectetur",
      gallery: "portfolio-gallery-branding",
      detailsLink: "/project-details"
    }
  ]
};

const Projects = () => {
  const { t } = useTranslation();
  const isotopeRef = useRef(null);
  const containerRef = useRef(null);
  const [activeFilter, setActiveFilter] = useState("*");

  useEffect(() => {
    const imagesLoaded = require("imagesloaded");
    const Isotope = require("isotope-layout");

    imagesLoaded(containerRef.current, () => {
      isotopeRef.current = new Isotope(containerRef.current, {
        itemSelector: ".portfolio-item",
        layoutMode: "masonry"
      });
    });

    projectData.items.forEach(item => {
      GLightbox({ selector: `.${item.gallery}`, touchNavigation: true, loop: true });
    });

    return () => isotopeRef.current?.destroy();
  }, []);

  const handleFilterClick = filter => {
    setActiveFilter(filter);
    isotopeRef.current?.arrange({ filter });
  };

  return (
    <section id="projects" className="projects section">
      <div className="container section-title" data-aos="fade-up">
        {/*            <h2>{t("Ihr Partner in Schlüsselangelegenheiten")}</h2>
                 <br/>
                <p>{t("Die Mitarbeiter sind das Beste an unserem Schlüsseldienst")}</p>
                 <br/>
                <p>Willkommen bei Schlüsseldienst in Kiel, Ihrem verlässlichen Partner in Kiel und Umgebung. Wir wissen, dass ein Anruf bei uns oft in einer Notlage erfolgt. Deshalb ist es unser oberstes Ziel, Ihnen schnell, effizient und zu fairen Festpreisen zu helfen. Bei uns gibt es keine versteckten Kosten oder bösen Überraschungen, wenn die Rechnung kommt.</p>
                <br/>
                <p>Auf unser erfahrenes Team können Sie sich zu jeder Uhrzeit verlassen. Mit unserer langjährigen Erfahrung seit 2012, bieten wir neben Schlüsseldienstleistungen auch Sicherheitstechnik und Schlüsseldienstseminare an. Mit unserem Schlüsseldienst in Kiel sind Sie immer auf der sicheren Seite.</p>*/}
        <p>{t("refrencesTexts.text1")}</p>
        <h2>{t("refrencesTexts.text2")}</h2>
        <p>{t("refrencesTexts.text3")}</p>
      </div>

      <div className="container">
        <div className="isotope-layout" data-layout="masonry">
          <ul className="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="100">
            {projectData.filters.map((filter, idx) => (
              <li key={idx} className={filter.value === activeFilter ? "filter-active" : ""}>
                <button
                  type="button"
                  data-filter={filter.value}
                  aria-pressed={filter.value === activeFilter}
                  onClick={() => handleFilterClick(filter.value)}
                >
                  {filter.label}
                </button>
              </li>
            ))}
          </ul>

          <div
            className="row gy-4 isotope-container"
            data-aos="fade-up"
            data-aos-delay="200"
            ref={containerRef}
          >
            {projectData.items.map(
              ({ id, category, imgSrc, title, subtitle, gallery, detailsLink }) => (
                <div
                  key={id}
                  className={`col-12 col-md-6 col-lg-4 portfolio-item isotope-item ${category}`}
                >
                  <div className="portfolio-content h-100">
                    <img
                      src={imgSrc}
                      className="img-fluid"
                      alt={title}
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="portfolio-info">
                      <h4>{title}</h4>
                      <p>{subtitle}</p>
                      <a
                        href={imgSrc}
                        title={title}
                        data-gallery={gallery}
                        className={`glightbox preview-link ${gallery}`}
                        aria-label={title}
                      >
                        <BsZoomIn aria-hidden="true" />
                      </a>
                      <Link
                        to={detailsLink}
                        title={t("More Details")}
                        aria-label={t("More Details")}
                        className="details-link"
                      >
                        <BsLink45Deg aria-hidden="true" />
                      </Link>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
